import React, { createContext, useContext, ReactNode } from 'react';

interface VideoAnalysisContextType {
  // Placeholder for now
}

const VideoAnalysisContext = createContext<VideoAnalysisContextType | undefined>(undefined);

interface VideoAnalysisProviderProps {
  children: ReactNode;
}

export const VideoAnalysisProvider: React.FC<VideoAnalysisProviderProps> = ({ children }) => {
  return (
    <VideoAnalysisContext.Provider value={{}}>
      {children}
    </VideoAnalysisContext.Provider>
  );
};

export const useVideoAnalysis = (): VideoAnalysisContextType => {
  const context = useContext(VideoAnalysisContext);
  if (context === undefined) {
    throw new Error('useVideoAnalysis must be used within a VideoAnalysisProvider');
  }
  return context;
};
